import { Resource } from '@teem/generic/resource';
import { Serializer } from '@teem/generic/serializer';
import * as moment from 'moment';

import {InvoiceDeliverable} from '@teem/models/invoice-deliverable';

export class InvoiceSerializer implements Serializer {
  fromJson(json: any): Invoice {
		let invoice = new Invoice(JSON.parse(JSON.stringify(json)));
    return invoice;
  }

  // Note: Currently this method is unused.
  toJson(invoice: Invoice): any {
  	let data:any = {
		title: invoice.title,
		invoice_type: invoice.invoice_type,
		invoice_number: invoice.invoice_number,
		invoice_date: invoice.invoice_date,
		invoice_time: invoice.invoice_time,
		client_id: invoice.client_id,
		total_amount: invoice.total_amount,
		project_type: invoice.project_type,
		include_tax: invoice.include_tax,
		tax_percent: invoice.tax_percent,
		delivery_fee: invoice.delivery_fee,
		delivery_with: invoice.delivery_with,
		tax_type: invoice.tax_type,
		payment_info: invoice.payment_info,
		additional_info: invoice.additional_info,
		status: invoice.status,
		online_payment_percent: invoice.online_payment_percent,
		action: invoice.action,
		client_has_email: invoice.client_has_email,
		save_default_payment_info: invoice.save_default_payment_info,
		save_default_additional_info: invoice.save_default_additional_info,
		qr_code_base64: invoice.qr_code_base64,
		share_link: invoice.share_link,
		currency: invoice.currency,
		buyer_first_name: invoice.buyer_first_name,
		buyer_last_name: invoice.buyer_last_name,
		buyer_address: invoice.buyer_address,
		buyer_vat_number: invoice.buyer_vat_number,
		buyer_cr_number: invoice.buyer_cr_number,
		zatca_enabled: invoice.zatca_enabled,
		zatca_push_status: invoice.zatca_push_status,
		zatca_is_production: invoice.zatca_is_production,
		zatca_invoice: invoice.zatca_invoice
  	}

  	if(invoice.uuid)
  		data.uuid = invoice.uuid;

  	if(invoice.items)
  		data.items = invoice.items;

  	if(invoice.payments)
  		data.payments = invoice.payments;

	return data;
  }
}

export  class Invoice implements Resource {
	public uuid: string;
	public title: string = null;
	public invoice_type: string = 'b2c';
	public invoice_number: number;
	public invoice_date: string = moment().format('DD/MM/YYYY');
	public invoice_time: string = null;
	public client_id: number = null;
	public status:string = 'pending';
	public is_draft:number = 0;
	public total_amount:number = 0;
	public payment_info: any;
	public additional_info: string;
	public project_type: string = 'fixed';
	public include_tax:boolean;
	public tax_percent: number;
	public tax_type: number;
	public discount_type: string = 'percentage';
	public discount: number;
	public delivery_fee: number;
	public delivery_with: string;
	public original_amount: number;
	public discounted_amount: number;
	// public deliverables: InvoiceDeliverable[] = []; // Todo - duplicate keys of items and deliverables. Need to remove one
	public items: InvoiceDeliverable[];
	public online_payment_percent:number = 0;
	public action:string = null;
	public save_default_payment_info:boolean = false;
	public save_default_additional_info:boolean = false;
	public client:any;
	public client_name: string;
	public paid_amount: number;
	public due_amount: number;
	public client_has_email: boolean = true;
	public user: any;
	public pay_url: string;
	public reference_number: string = null;
	public payments: any = null;
	public parent_invoice_id: number = null;
	public parent_invoice: any = null;
	public qr_code_base64: string = '';
	public share_link: string = null;
	public currency: string;

	public buyer_first_name: string = null;
	public buyer_last_name: string = null;
	public buyer_address: string = null;
	public buyer_vat_number: string = null;
	public buyer_cr_number: string = null;

	public zatca_enabled: string = null;
	public zatca_push_status: string = null;
	public zatca_is_production: boolean = false;
	public zatca_invoice: string = null;

	constructor(input?:any) {

		if(input){
			Object.assign(this, input);

			if(input.payment_info){
				try{
					let paymentInfo = JSON.parse(JSON.stringify(input.payment_info));
					this.payment_info = paymentInfo;
				} catch(err) {
					console.error(err);
				}
			}

			if(input.items && input.items.length){
				this.items = [];
				input.items.forEach(item => {
					this.items.push(new InvoiceDeliverable(item))
				});
			}
		}
	}
}
